// Firebase Configuration
// Replace these values with your Firebase project config
// Get them from: Firebase Console > Project Settings > General > Your apps

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// Project: mokleslajimi
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCR-S2S3h9LuvdlJegbLeXwczwEJJmjePg",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mokleslajimi.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mokleslajimi",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mokleslajimi.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "912857446984",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:912857446984:web:a29f16c40b81b0c2b7767d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Authentication
export const auth = getAuth(app);

export default app;

